import { ReactNode, useState } from 'react'
import { Field, FieldProps } from 'formik'
import { Select as ASelect } from 'antd'
import { Required, SelectLabel, SelectWrapper } from './styles'
import _ from 'lodash'
import Indication from 'components/Indication'
import { SetState } from 'globals'

interface IProps {
  children: ReactNode,
  name: string,
  label?: string,
  defaultValue?: string,
  showSearch?: boolean,
  placeholder?: string,
  hideError?: boolean,
  widthAuto?: boolean,
  noBottomPadding?: boolean,
  nbPerLine?: number,
  onChange?: (value: string) => void,
  disabled?: boolean,
  notFoundContent?: string,
  required?: boolean
}

const Select = (props: IProps) => {
  const { name, label, defaultValue, showSearch, placeholder, hideError,
    widthAuto, noBottomPadding, nbPerLine, disabled, notFoundContent, onChange,
    required, children } = props
  const [entered, setEntered] = useState(false)

  return (
    <Field name={name}>
      {(props: FieldProps) =>
        <SelectWrapper
          className="ant-select-wrapper"
          hasError={!!props.form.errors[name] && entered}
          nbPerLine={nbPerLine || 0}
          noBottomPadding={noBottomPadding}
        >
          {label &&
            <SelectLabel>
              {required &&
                <Required>* </Required>
              }
              {label}
            </SelectLabel>
          }

          <ASelect
            defaultValue={defaultValue}
            value={_.isEmpty(props.field.value) || props.field.value === null ? undefined : props.field.value}
            onChange={onSelectChange(props, name, setEntered, props.form.setFieldValue, onChange)}
            onBlur={props.field.onBlur}
            showSearch={showSearch}
            placeholder={placeholder}
            dropdownClassName={widthAuto ? 'ant-select-dropdown-auto' : ''}
            disabled={disabled}
            notFoundContent={notFoundContent}
          >
            {children}
          </ASelect>

          {(props.form.errors[name] && !hideError && entered) &&
            <Indication
              hasError={!!props.form.errors[name] && entered}
            >
              {props.form.errors[name]}
            </Indication>
          }
        </SelectWrapper>
      }
    </Field>
  )
}

const onSelectChange = (
    props: FieldProps,
    name: string,
    setEntered: SetState<boolean>,
    setFieldValue: (name: string, value: string) => void,
    onChange?: (value: string) => void
) => (value: string) => {
  setEntered(true)

  setFieldValue(name, value)

  if (onChange) {
    onChange(value)
  }
}

Select.defaultProps = {
  showSearch: false,
  widthAuto: true,
  noBottomPadding: false,
  disabled: false,
  required: false
}

const Option = ASelect.Option

export { Option }
export default Select
